<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      unit="活动"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="120px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <!--width是整个窗口的宽度-->
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="活动名称" prop="ActivityName">
              <el-input
                v-model="data.ActivityName"
                placeholder="请填写活动名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="首页展示" prop="ShowIndex">
              <el-select v-model="data.ShowIndex" placeholder="请选择首页展示">
                <el-option :value="1" label="是"></el-option>
                <el-option :value="0" label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="首页固定展示" prop="ShowEnd">
              <el-select v-model="data.ShowEnd" placeholder="首页固定展示">
                <el-option :value="1" label="是"></el-option>
                <el-option :value="0" label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item
              :label="isMB ? '' : '封面图片'"
              :label-width="isMB ? '0' : ''"
              prop="CoverPhoto"
            >
              <el-divider v-if="isMB">封面图片</el-divider>
              <single-pic-upload
                v-model="data.CoverPhoto"
                type="CoverPhoto"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
              <span style="color: red">最佳宽高比例9：4</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="isMB ? '' : '活动内容'"
              :label-width="isMB ? '0' : ''"
              prop="ActivityNotes"
            >
              <el-divider v-if="isMB">活动内容</el-divider>
              <editor ref="editor" v-model="data.ActivityNotes"></editor>
              <el-input v-model="data.ActivityNotes" v-show="false"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="活动简介" prop="ActivityBrief">
              <el-input
                v-model="data.ActivityBrief"
                placeholder="请填写活动简介"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="活动地点" prop="ActivityAddress">
              <el-input
                v-model="data.ActivityAddress"
                placeholder="请填写活动地点"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="开始时间" prop="BeginTime">
              <el-date-picker
                v-model.trim="data.BeginTime"
                placeholder="请选择时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="结束时间" prop="EndTime">
              <el-date-picker
                v-model.trim="data.EndTime"
                placeholder="请选择时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="咨询电话" prop="SeekPhone">
              <el-input
                v-model="data.SeekPhone"
                placeholder="请填写咨询电话"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="报名截止时间" prop="EnrollEndtime">
              <el-date-picker
                v-model.trim="data.EnrollEndtime"
                placeholder="请选择时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="可报名总人数" prop="EnrollNumber">
              <el-input v-model="data.EnrollNumber" type="number"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number
                v-model="data.OrderId"
                :min="0"
                :precision="0"
              ></el-input-number>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="发布时间" prop="ReleaseTime">
              <el-date-picker
                v-model.trim="data.ReleaseTime"
                placeholder="请选择时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <template slot="footer" slot-scope="{ isLoading }">
        <el-button type="primary" :loading="isLoading" @click="toSave(0)"
          >保 存</el-button
        >
        <el-button
          type="success"
          @click="toSave(1)"
          v-if="data.State == 0 || data.State == 3"
          >提 交</el-button
        >

        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import editor from "@/components/common/editor.vue";
import singlePicUpload from "@/components/common/photo/singleUpload"; //上传图片组件

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    editor,
    singlePicUpload,
  },
  data() {
    return {
      data: {
        //每次刷新页面后各编辑框的初始值，例如某个字段如果不清空，继承上一次编辑的内容，则不赋予初值就好
        RecordId: 0,
        ActivityName: "",
        ShowIndex: 0,
        ShowEnd: 0,
        CoverPhoto: "",
        ActivityNotes: "",
        ActivityBrief: "",
        BeginTime: null,
        EndTime: null,
        SeekPhone: "",
        EnrollMust: 1,
        EnrollEndtime: null,
        EnrollNumber: null,
        ReleaseTime: null,
        OrderId: 0,
        State: 0,
        ActivityAddress: "",
      },
      saveState: 0,
      DelSess: [],
      list: [],
      api: require("@/api/operate/activity").default,
      isMB: this.$store.state.isMB,
      rules: {
        ActivityName: [{ required: true, message: "活动名称不能为空" }], //TermName这个名称就必须和上面各类录入框的prop属性值一致，就是控制同名的录入框的必填
        CoverPhoto: [{ required: true, message: "封面不能为空" }],
        BeginTime: [{ required: true, message: "开始时间为空" }],
        EndTime: [{ required: true, message: "结束时间不能为空" }],
        EnrollEndtime: [{ required: true, message: "报名截止时间不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
      sess: true,
    };
  },
  methods: {
    onCreateOpened(row) {
      this.data.ReleaseTime = this.$commonJs.getNowShortDatetimeString();
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(row) {},
    onBeforeSave() {
      console.log(this.$refs.dialog, "this.$refs.dialog");
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        if (!this.data.ActivityNotes) {
          this.$message.warning("活动内容不能为空");
          return false;
        }
      });
      var data = this.$commonJs.obj.removeNullKey(this.data);
      if (data.EndTime < data.BeginTime) {
         this.$message.warning("结束日期不能小于开始日期");
         return false;
      }
      if (data.BeginTime < data.EnrollEndtime) {
         this.$message.warning("开始日期不能小于报名截止日期");
         return false;
      }

      if (this.saveState == 1) {
        console.log(data);
        this.$refs.dialog.isLoading = true;
        this.api.submit(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message.error(res.Msg);
          }
        });
        return false;
      }
    },

    toSave(t) {
      this.saveState = t;
      console.log(t);
      this.$refs.dialog.save();
    },

    save() {},
    onClosed() {},
  },
};
</script>
  <style scoped>
.row-tb-head {
  height: 40px;
  line-height: 40px;
  width: 100%;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.tb-c-head.el-table {
  .el-table__header-wrapper {
    table thead th {
      background-color: #f9f9f9;
    }
  }
  .el-table__fixed-right {
    .el-table__fixed-header-wrapper {
      .el-table__header {
        thead th {
          background-color: #f9f9f9;
        }
      }
    }
  }
  .el-table__fixed {
    .el-table__fixed-header-wrapper {
      .el-table__header {
        thead th {
          background-color: #f9f9f9;
        }
      }
    }
  }
}
</style>